import React from 'react';
import Skeleton from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';

const PropertyDetailsSkeleton = () => {
	return (
		<div className="w-100 h-100">
			<div className="row position-relative m-auto" id="overview">
				<Skeleton height={44}/>
			</div>
			<div className="row max-w-xl m-auto">
				<div className="col-12 col-lg-8">
					<Skeleton height={420} style={{width: '100%'}}/>
				</div>
				<div className="col-4 p-0 ps-1 align-content-between">
					<Skeleton height={208} style={{width: '100%'}}/>
					<Skeleton height={208} style={{width: '100%'}}/>
				</div>
			</div>
			<div className="row max-w-xl m-auto mt-3">
				<div className="col-12 col-lg-8">
					<Skeleton height={28.75} style={{width: '100%'}}/>
					<Skeleton height={73.25} style={{width: '100%'}}/> 
				</div>
				<div className="col-4 p-0 ps-1">
					<Skeleton height={102} style={{width: '100%'}}/>
				</div>
			</div>
			<div className="row max-w-xl m-auto mt-3">
				<div className="col-12 col-lg-8">
					<Skeleton height={500} style={{width: '100%'}}/>
				</div>
			</div>
		</div>
	);
};

export default PropertyDetailsSkeleton;
